<template>
  <div :class="['form-element', hidden && 'd-none']">
    <FormLabel
      v-if="label"
      v-bind="{
        label,
        required,
        disabled,
        description,
        descriptionType,
        dirty,
        error,
        id
      }"
    />
    <div>
      <div
        v-for="(item,i) in courseSet.value"
        :key="i"
        class="d-flex align-items-start"
      >
        <AppTooltip>
          <AppButton
            v-if="i!==0"
            class="mr-2 rounded-5 bg-light px-2 d-flex align-items-center"
            style="height:34px;"
            data-test="toggle_logic"
            @click="courseSet.logic = unselectedLogic"
          >
            {{ courseSet.logic }}
          </AppButton>
          <template #tooltip>Change to <strong>{{ unselectedLogic.toUpperCase() }}</strong></template>
        </AppTooltip>
        <FormCourseSetSelect
          v-model="courseSet.value[i]"
          :excludedIds="courseSet.value"
          :config="{...config, multiple:false }"
          :placeholder="`Select ${$localize('course set')}`"
          class="flex-1"
        />
        <AppTooltip>
          <AppButton
            v-if="i!==0"
            :raised="true"
            variant="danger"
            style="height:34px;"
            class="ml-2 px-2 rounded-5"
            data-test="delete_requisite_courseSet"
            @click="deleteValue(i)"
          >
            <AppIcon name="delete" />
          </AppButton>
          <template #tooltip>Delete</template>
        </AppTooltip>
        <AppTooltip>
          <AppButton
            v-if="i===0"
            :raised="true"
            style="height:34px;"
            class="ml-2 px-2 rounded-5"
            data-test="add_requisite_courseSet"
            @click="addNewValue"
          >
            <AppIcon name="add" />
          </AppButton>
          <template #tooltip>Add additional {{ $localize('course set', 'plural') }}</template>
        </AppTooltip>
      </div>
    </div>
    <AppButton
      :raised="true"
      :disabled="!currentSelections.length"
      class="mb-2"
      style="height:34px;"
      @click="addCourseSet"
    >Add</AppButton>
    <section v-if="normalizedValue.length">
      <AppSortable
        :value="normalizedValue"
        keySuffix="cs"
        class="border rounded-5"
        @input="update"
      >
        <template #default="{ item: courseSet, key }">
          <div
            class="d-flex border-bottom pr-2 py-2 pl-3 align-items-center"
            title="Drag to sort"
          >
            <AppIcon
              name="drag_indicator"
              class="mr-2"
              style="opacity:0.5"
            />
            <div
              class="mr-2 flex-1"
              v-html="courseSet.value.map(getCourseSetLabel).join(` </br><strong>${(courseSet.logic).toUpperCase()}</strong> `)"
            />
            <AppButton
              variant="danger"
              @click="deleteCourseSet(key)"
            >
              <AppIcon name="clear" />
            </AppButton>
          </div>
        </template>
      </AppSortable>
    </section>
  </div>
</template>
<script>
import FormMixin from './FormMixin'
import FormLabel from './FormLabel'
import FormCourseSetSelect from './FormCourseSetSelect'
import { mapGetters } from 'vuex'
import _isObject from 'lodash/isObject'
import { capitalize } from '@shared/utils/string'

export default {
  mixins: [ FormMixin ],
  components: { FormLabel, FormCourseSetSelect },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  data () {
    return {
      courseSet: {
        value: [ undefined ], // setting undefined so that the field shows up
        logic: 'and',
      },
    }
  },
  computed: {
    ...mapGetters('curriculumCourses', [ 'courseSetById' ]),
    normalizedValue () { // Only used untill all data is updated to support and/or logic
      return this.value.map(v => _isObject(v) ? v : { value: [ v ], logic: 'and' })
    },
    currentSelections () {
      return this.courseSet.value.filter(Boolean)
    },
    unselectedLogic () {
      return [ 'and', 'or' ].find(logic => logic !== this.courseSet.logic)
    },
  },
  methods: {
    addNewValue () {
      this.courseSet.value.push(undefined)
    },
    deleteValue (index) {
      this.courseSet.value.splice(index, 1)
    },
    deleteCourseSet (key) {
      this.$emit('input', this.normalizedValue.filter((courseSet, index) => index !== key))
    },
    addCourseSet () {
      if (this.currentSelections.length) {
        this.$emit('input', [ ...this.normalizedValue, { ...this.courseSet, value: this.currentSelections } ])
        this.courseSet.value = [ undefined ]
      }
    },
    getCourseSetLabel (courseSetId) {
      const courseSet = this.courseSetById(courseSetId)
      return `<span>${courseSet.name || `Untitled ${capitalize(this.$localize('course set'))}`}</span>`
    },
  },
}
</script>
